export enum ImageQualityOption {
  ORIGINAL = 'original',
  ENHANCED_4K = 'enhanced_4k',
}
